import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export const sampleEvents = {
  onTrackingChanged: new SimpleEventDispatcher<{ sampleIds: number[] }>(),
  onSampleSentFromSupplier: new SignalDispatcher(),
  onSampleReceivedFromSupplier: new SignalDispatcher(),
  onSampleReadyDateUpdated: new SignalDispatcher(),
  onSamplesLost: new SignalDispatcher(),
  onSampleRemovedFromTransportRequest: new SignalDispatcher(),
  onSamplesUpdated: new SignalDispatcher(),
  onSamplesActionPerformed: new SignalDispatcher(),
};
